









































































import {
  Component,
  Vue,
  Prop,
} from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import AdminService from '@/services/admin.service';

@Component({
  components: {
  },
})
export default class AdminUtils extends Vue {

  @Getter private hasPermission: any;

  private encodedString: string = '';
  private decodedString: string = '';
  private passwordString: string = '';
  private decoderFormValid: boolean = false;
  private errorString: string = '';
  private decoding: boolean = false;

  public mounted() {
    if (!this.hasPermission('administration:view')) {
      this.$router.push('/');
    }
  }

  public async decodeString() {
    (this.$refs.decoderForm as any).validate();
    if (!this.decoderFormValid) {
      return;
    }
    this.decoding = true;
    try {
      const resp = await AdminService.decodeString(this.encodedString, this.passwordString);
      this.decodedString = resp.result;
      this.errorString = '';
    } catch (e) {
      const err = e as Error;
      this.errorString = err.message;
    } finally {
      this.decoding = false;
    }
  }
}
